// import external dependencies
import 'jquery';


// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


/*import './wow.js';
new WOW().init();*/


$(function () {
    $('#top-nav').clone().appendTo('.menu-fixed');

    $('.slide-menu').on('click', function (e) {
        e.preventDefault();
        $('.slide-in-menu').toggleClass('open');
        $('body').toggleClass('slide-in-menu-open');
    });

    $(document).on('click', function (e) {
        var container = $('.slide-menu, .slide-in-menu');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('body').removeClass('slide-in-menu-open');
            $('.slide-in-menu').removeClass('open');
        }
    });

    $('.show-home-menu').on('click', function(e) {
        e.preventDefault();
        $('.home-submenu').slideToggle();
        $('.vehicle-submenu').slideUp();
        $('html,body').animate({scrollTop: 0}, 200);
    });

    $('.show-vehicle-menu').on('click', function(e) {
        e.preventDefault();
        $('.vehicle-submenu').slideToggle();
        $('.home-submenu').slideUp();
        $('html,body').animate({scrollTop: 0}, 200);
    });

    $('.slidein-sub').on('click', function(e) {
        e.preventDefault();
        $(this).siblings('ul.nav-item').slideToggle();
    });

    $(window).scroll(function() {
        slider();
    });

    function slider() {
        var offset = $('#top-nav').offset();
        var scrollTop = $(window).scrollTop();
        if(scrollTop > (offset.top - 0)) {
            $('.menu-fixed').show();
        } else {
            $('.menu-fixed').hide();
        }
    }

    slider();
});


// WEBPACK FOOTER //
// ./scripts/main.js